var _circle, _circle2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardlogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6874,
    cy: 22.4601,
    r: 22.3304,
    fill: "url(#paint0_linear_1_4477)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6874,
    cy: 22.4601,
    r: 22.3304,
    fill: "#F6E6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1618 24.0912L28.4828 20.3944C28.1889 18.7974 28.042 17.9988 27.4613 17.5266C26.8807 17.0544 26.0456 17.0533 24.3766 17.0533H19.8914C18.2224 17.0533 17.3884 17.0533 16.8067 17.5266C16.226 17.9988 16.0791 18.7974 15.7852 20.3944L15.1062 24.0912C14.4982 27.406 14.1932 29.0639 15.1306 30.1512C16.0679 31.2406 17.8008 31.2406 21.2645 31.2406H23.0035C26.4672 31.2406 28.2001 31.2406 29.1374 30.1522C30.0748 29.0639 29.7708 27.406 29.1618 24.0923",
    stroke: "#A409B8",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1338 20.6002V27.1871M19.6003 25.1604L22.1338 27.6938L24.6672 25.1604M31.2541 21.1069C31.4107 21.0288 31.5527 20.9242 31.6737 20.7978C32.2675 20.1837 32.2675 19.1916 32.2675 17.2074C32.2675 15.2232 32.2675 14.2321 31.6737 13.616C31.0798 12.9999 30.1252 12.9999 28.214 12.9999H16.0535C14.1423 12.9999 13.1877 12.9999 12.5938 13.616C12 14.2321 12 15.2242 12 17.2074C12 19.1906 12 20.1827 12.5938 20.7978C12.7154 20.9248 12.8553 21.0278 13.0134 21.1069",
    stroke: "#A409B8",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4477",
    x1: 18.2998,
    y1: -1.50024,
    x2: 44.7998,
    y2: 43.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00345C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardlogo3);
export default __webpack_public_path__ + "static/media/dashboardlogo3.4d8299ed8509a3cb1645c3af7a3696c8.svg";
export { ForwardRef as ReactComponent };